// extracted by mini-css-extract-plugin
module.exports = {"articleCard":"ArticleCard_articleCard___2_B4"};